export const UI_UX_types = {
    INITIALIZE: 'INITIALIZE',
    HERO_ANIMATE: 'HERO_ANIMATE',
    TICK: 'TICK',
    GET_FPS: 'GET_FPS',
    TAB_MODIFY: 'TAB_MODIFY',
    CLICK_FX: 'CLICK_FX',
    SHOW_TRELLO_MODAL: 'SHOW_TRELLO_MODAL',
    CLOSE_TRELLO_MODAL: 'CLOSE_TRELLO_MODAL',
    SET_LOCATION: 'SET_LOCATION',
    TEXTAREA_UPDATE: 'TEXTAREA_UPDATE',
    FORM_UPDATE: 'FORM_UPDATE',
    SET_LANG: 'SET_LANG',
    SET_AUTH_FORM_TYPE: 'SET_AUTH_FORM_TYPE',
    SET_CONTACT_METHOD: 'SET_CONTACT_METHOD',
    SET_ENV: 'SET_ENV',
    SET_TIP_OF_THE_DAY: 'SET_TIP_OF_THE_DAY',
    SET_COOKIES_ALLOWED: 'SET_COOKIES_ALLOWED',
    SET_COOKIES_ALLOWED_BY_USER: 'SET_COOKIES_ALLOWED_BY_USER',
    TOGGLE_FUTURES: 'TOGGLE_FUTURES',
    TOGGLE_TOOLBAR: 'TOGGLE_TOOLBAR',
    TOGGLE_USER_LANG_SELECT: 'TOGGLE_USER_LANG_SELECT',
    TOGGLE_COOKIES_MODAL: 'TOGGLE_COOKIES_MODAL',
    NOTIFY: 'NOTIFY',
    NOTIFY_DESTROY: 'NOTIFY_DESTROY'
};

export const authTypes = {
    // checks
    IPIFY: 'IPIFY',
    SET_JWT: 'SET_JWT',
    JWT_IS_NOT_EXIST: 'JWT_IS_NOT_EXIST',
    SET_CURREN_USER_COOKIES: 'SET_CURREN_USER_COOKIES',
    USER_AUTH: 'USER_AUTH',
    GUEST_INIT: 'GUEST_INIT',
    USER_LOGOUT: 'USER_LOGOUT',
    USER_UPDATE: 'USER_UPDATE',
    USER_DELETE: 'USER_DELETE',
    SET_USER_ID: 'SET_USER_ID',
    SET_USER_IP: 'SET_USER_IP',
    ROBOT_CHECK: 'ROBOT_CHECK',
    GET_ALL_USERS: 'GET_ALL_USERS',
    USER_REGISTER: 'USER_REGISTER',
    TOGGLE_REMEMBER_ME: 'TOGGLE_REMEMBER_ME',
    USER_SET_PASSWORD: 'USER_SET_PASSWORD',
    USER_FORGOT_PASSWORD: 'USER_FORGOT_PASSWORD',
    USER_NAME_AUTO_UPDATE: 'USER_NAME_AUTO_UPDATE',
    USER_EMAIL_AUTO_UPDATE: 'USER_EMAIL_AUTO_UPDATE',
    USER_SUBJECT_AUTO_UPDATE: 'USER_SUBJECT_AUTO_UPDATE',
    USER_TG_MESSAGE_AUTO_UPDATE: 'USER_TG_MESSAGE_AUTO_UPDATE',
    USER_MAIL_MESSAGE_AUTO_UPDATE: 'USER_MAIL_MESSAGE_AUTO_UPDATE'
};
